import { Module } from '@nestjs/common';
import { JwtModule } from '@nestjs/jwt';
import { PassportModule } from '@nestjs/passport';
import { envs } from 'src/config';
import { StoreAuthController } from './store-auth.controller';
import { StoreAuthService } from './store-auth.service';
import { StoreJwtStrategy } from './store-jwt.strategy';

@Module({
  imports: [
    PassportModule,
    JwtModule.register({ secret: envs.jwtSecret }),
  ],
  controllers: [StoreAuthController],
  providers: [StoreAuthService, StoreJwtStrategy],
})
export class StoreAuthModule {}
